
import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA} from "@angular/material";
import { MatDialogRef} from '@angular/material';
import {ToastyService, ToastyConfig, ToastOptions, ToastData} from 'ng2-toasty';


@Component({
  selector: 'are-you-sure-dialog',
  templateUrl: './are-you-sure-dialog.component.html',
  styleUrls: ['are-you-sure-dialog.component.css']
})
export class AreYouSureDialogComponent {

  cascad : boolean;

  constructor(@Inject(MAT_DIALOG_DATA) public data : any,public dialogRef: MatDialogRef<AreYouSureDialogComponent>) {
    this.cascad = data.cascad;
  }

  close(result : string){
    this.dialogRef.close(result);
  }

}



// WEBPACK FOOTER //
// ./src/app/centralPanel/dependenQuestions/are-you-sure-dialog/are-you-sure-dialog-component.ts